export default __webpack_public_path__ + "images/cbee6fbf502e4071f8d8042e0ed265cd.svg";